import { Gen5Config } from '@terragotech/gen5-config-lib';

export const getCustomPageList = (config:Gen5Config, aggType:string) => {
  const pages = config.pagesConfig;
  return pages
    ? Object.entries(pages)
      .filter(([_, e]) => e.aggregateType === aggType)
      .map(([key, _]) => key)
    : [];
};